import resolve from '../../modules/api/resolve';
import { apiPost, generateFormData } from '../../modules/apiHelper';

export default {
  async nominateSupportAdmin(context, payload) {
    const result = await resolve(apiPost('nominate_adm', generateFormData(payload), 87));

    return !!result;
  },

  async removeSupportAdmin(context, payload) {
    const result = await resolve(apiPost('rm_adm', generateFormData(payload), 89));

    return !!result;
  },

  async getProgramSupportAdmins(context, programId) {
    const result = await resolve(apiPost('prog_admin_list', generateFormData({ progid: programId }), 88));

    if (result) {
      return result.prog_admin_list;
    }

    return [];
  },

  async getOpenTickets(context) {
    const companyid = context.getters.supportContextId;
    const programid = context.getters.supportProgramContextId;
    if (!companyid || !programid) {
      return false;
    }

    const result = await resolve(apiPost('ticket_list', generateFormData({
      companyid,
      progid: programid,
    }), 90));

    if (result) {
      // reduce the number of requests to the server by fetching the user data in the same request
      // unique users are fetched from the server
      const uniqueUsers = new Set();

      result.ticket_list.forEach((ticket) => {
        uniqueUsers.add(ticket.senderid);
      });

      const users = await Promise.all(Array.from(uniqueUsers).map((userId) => context.dispatch('getUserData', userId)));

      return result.ticket_list.map((ticket) => {
        // eslint-disable-next-line eqeqeq
        const sender = users.find((user) => user.id == ticket.senderid);

        return {
          ...ticket,
          sender,
        };
      });
    }

    return false;
  },

  async getResolvedTickets(context) {
    const companyid = context.getters.supportContextId;
    const programid = context.getters.supportProgramContextId;
    if (!companyid || !programid) {
      return false;
    }

    const result = await resolve(apiPost('ticket_resolved_list', generateFormData({
      companyid,
      progid: programid,
    }), 90));

    if (result) {
      // reduce the number of requests to the server by fetching the user data in the same request
      // unique users are fetched from the server
      const uniqueUsers = new Set();
      const uniqueAdmins = new Set();

      result.ticket_resolved_list.forEach((ticket) => {
        uniqueUsers.add(ticket.senderid);
        uniqueAdmins.add(ticket.adminid);
      });

      const [users, admins] = await Promise.all([
        Promise.all(Array.from(uniqueUsers).map((userId) => context.dispatch('getUserData', userId))),
        Promise.all(Array.from(uniqueAdmins).map((adminId) => context.dispatch('getUserData', adminId))),
      ]);

      return result.ticket_resolved_list.map((ticket) => {
        // eslint-disable-next-line eqeqeq
        const sender = users.find((user) => user.id == ticket.senderid);
        // eslint-disable-next-line eqeqeq
        const resolvedBy = admins.find((admin) => admin.id == ticket.adminid);

        return {
          ...ticket,
          sender,
          resolvedBy,
        };
      });
    }

    return false;
  },

  async resolveTicket(context, payload) {
    const result = await resolve(apiPost('resolve_ticket', generateFormData({
      ...payload,
      adminid: payload.adminid || context.rootState.User?.id,
    }), 91));

    return result;
  },

  async getTicketDetails(context, ticketId) {
    const result = await resolve(apiPost('ticket_dt', generateFormData({
      ticketid: ticketId,
    }), 90));

    if (result) {
      const ticket = result.ticket_dt[0];
      const sender = await context.dispatch('getUserData', ticket.senderid);

      if (Number(ticket.adminid) > 0) {
        const admin = await context.dispatch('getUserData', ticket.adminid);

        return {
          ...ticket,
          sender,
          resolvedBy: admin,
        };
      }

      return {
        ...ticket,
        sender,
      };
    }

    return result;
  },
};
